import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ExternalNotificationState } from './external-notification.state';

export const selectExternalNotificationState = createFeatureSelector<ExternalNotificationState>('externalNotification');

export const selectNotifications = createSelector(
  selectExternalNotificationState,
  (state: ExternalNotificationState) => state.notifications,
);

export const selectPagination = createSelector(
  selectExternalNotificationState,
  (state: ExternalNotificationState) => state.pagination,
);

export const selectFilter = createSelector(
  selectExternalNotificationState,
  (state: ExternalNotificationState) => state.filter,
);

export const selectLoading = createSelector(
  selectExternalNotificationState,
  (state: ExternalNotificationState) => state?.loading ?? false,
);

export const selectError = createSelector(
  selectExternalNotificationState,
  (state: ExternalNotificationState) => state.error,
);

export const selectIsFilterOpen = createSelector(
  selectExternalNotificationState,
  (state: ExternalNotificationState) => state.isFilterOpen,
);

// Computed selectors
export const selectHasNotifications = createSelector(
  selectNotifications,
  (notifications) => notifications && notifications.length > 0,
);

export const selectHasActiveFilter = createSelector(selectFilter, (filter) => {
  return Object.keys(filter).some((key) => {
    const value = filter[key as keyof typeof filter];
    return value !== undefined && value !== null && value !== '';
  });
});

export const selectActiveFiltersCount = createSelector(selectFilter, (filter) => {
  const { Page, PageSize, ...contentFilters } = filter;
  return Object.values(contentFilters).filter((value) => value !== undefined && value !== null && value !== '').length;
});

export const selectNotificationCount = createSelector(selectNotifications, (notifications) =>
  notifications ? notifications.length : 0,
);

// Pagination selectors
export const selectCurrentPage = createSelector(selectPagination, (pagination) => pagination?.currentPage ?? 1);

export const selectPageSize = createSelector(selectPagination, (pagination) => pagination?.pageSize ?? 15);

export const selectTotalItems = createSelector(selectPagination, (pagination) => pagination?.totalItems ?? 0);

export const selectTotalPages = createSelector(selectPagination, (pagination) => pagination?.totalPages ?? 0);

export const selectHasPreviousPage = createSelector(selectCurrentPage, (currentPage) => currentPage > 1);

export const selectHasNextPage = createSelector(
  selectCurrentPage,
  selectTotalPages,
  (currentPage, totalPages) => currentPage < totalPages,
);
